/**
 * A schema specified for entities to be parsed from step.
 */
export default class StepEntitySchema {
    /**
     * Construct the schema
     *
     * @param constructors The constructor array matching the entity type IDs for this entity.
     * @param parser The STEP parser used to extract entities that matches this schema.
     * @param queries The set of queries including subtypes to be able to read data from a type index.
     */
    /* Note that ES lint doesn't parse the typescript meaning of this constructor
     * correctly. */
    constructor(constructors, parser, queries, reflection) {
        this.constructors = constructors;
        this.parser = parser;
        this.queries = queries;
        this.reflection = reflection;
    }
}
